
import { Component, Prop, Vue } from 'vue-property-decorator';
import {camelCase} from '@/utils/strings';
@Component
export default class Col extends Vue {
    @Prop({default:6}) number !:number;
    @Prop() phone !:number;
    @Prop() phoneWide !:number;
    @Prop() phablet !:number;
    @Prop() tabletSmall !:number;
    @Prop() tablet !:number;
    @Prop() desktop !:number;
    @Prop() desktopWide !:number;
    @Prop() backgroundImage ?:string;
    @Prop() backgroundColor ?:string;
    @Prop({default:false}) center ?:boolean;

    classname( ){
      let classname = `grid-col--${this.number}`;
      let breakpoints = ['phone', 'phone-wide', 'phablet', 'tablet-small', 'tablet', 'desktop', 'desktop-wide'];
      breakpoints.map(breakpoint => {
        if(this.$props[camelCase(breakpoint)])
          classname += ` grid-col-${breakpoint}-${this.$props[camelCase(breakpoint)]}`;
            
      });
      if(this.center)
        classname += ' center';
        
      return classname;
    }
}
